













import {Vue, Component, Prop} from 'vue-property-decorator';
import {FilterDateData} from '@/types';

@Component
export default class PageDateFilterBtns extends Vue {
  @Prop({required: true}) private items!: FilterDateData;

  private selectDate(item: FilterDateData, idx: number) {
    if (!item.selected) {
      this.$emit('change', idx);
    }
  }
}
